<div class="data-display-group">
  <div class="data-display-group__label">{{ label }}</div>
  <div class="data-display-group__value">{{ renderer(value) | emptyValue }}</div>
</div>
